import { createSlice } from '@reduxjs/toolkit'
import { RootState } from 'store'
import { getProviders } from './thunks'

const initialState: ProvidersState = {
  providers: [],
  status: 'idle',
  error: null,
}

const slice = createSlice({
  name: 'providers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProviders.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(getProviders.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(getProviders.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.providers = action.payload
      })
  },
})

export const selectProviders = (state: RootState): ProvidersState => state.providers

export default slice.reducer
